/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ProductBulkUpdate {
    angular.module("meevo.plugins.productBulkUpdate", []);
}